module.exports = __webpack_public_path__ + "static/media/multi-unit.783b52eb.svg";